import api from '../services/api';

interface IDownloadReport {
  template: string;
  dados: any;
  reportName: string;
}

export const downloadReport = async ({
  dados,
  reportName,
  template,
}: IDownloadReport): Promise<boolean> => {
  const payload = {
    template,
    dados,
    reportName,
  };

  try {
    const response = await api.post('/reports/generate', payload, {
      responseType: 'blob',
    });

    const fileBlob = new Blob([response.data], { type: 'application/pdf' });
    const fileUrl = window.URL.createObjectURL(fileBlob);

    // 🔹 1 - Abrir o PDF em uma nova aba
    window.open(fileUrl, '_blank');

    // 🔹 2 - Baixar o PDF
    const link = document.createElement('a');
    link.href = fileUrl;
    link.setAttribute('download', `${payload.reportName}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.parentNode?.removeChild(link);

    // 🔹 3 - Revogar a URL temporária depois de um tempo
    setTimeout(() => {
      window.URL.revokeObjectURL(fileUrl);
    }, 1000);

    return true;
  } catch (error) {
    return false;
  }
};
